import { memo } from "react";
export const Seperator = memo(() => {
    return <hr className="my-1 border-t border-light" />;
});

Seperator.displayName = "Seperator";
